module.exports = __webpack_public_path__ + "static/media/map404.d399bff3.svg";